import { useMemo, useState } from 'react'
import { Button } from '../../../../../components/Button/Button'
import { isValidEmail } from '../../../../../common/util'
import { Form } from 'react-bootstrap'

export interface LinkNewEmailModalBodyProps {
  onSendLinkClicked: (email: string) => void
  isSending: boolean
  currentUserEmail?: string
  existingDelegatedEmails: string[]
}

export const LinkNewEmailModalBody = ({ onSendLinkClicked, isSending, currentUserEmail, existingDelegatedEmails }: LinkNewEmailModalBodyProps) => {
  const [email, setEmail] = useState('')

  const validation = useMemo(() => {
    if (!isValidEmail(email)) {
      return { isValid: false, error: null }
    }

    const lowerEmail = email.toLowerCase().trim()
    const currentUserEmailLower = currentUserEmail?.toLowerCase().trim()

    if (currentUserEmailLower && lowerEmail === currentUserEmailLower) {
      return { isValid: false, error: "Can't add your own email address" }
    }

    if (existingDelegatedEmails.some((e) => e.toLowerCase() === lowerEmail)) {
      return { isValid: false, error: 'This email is already linked' }
    }

    return { isValid: true, error: null }
  }, [email, currentUserEmail, existingDelegatedEmails])

  return (
    <>
      <p>Enter an email address and we'll send a verification link to confirm it's yours.</p>

      <Form.Label>Email</Form.Label>
      <Form.Control id='email' type='email' placeholder='name@example.com' disabled={isSending} onChange={(e) => setEmail(e.target.value)} />
      {validation.error ? <Form.Text className='d-block text-danger mt-2'>{validation.error}</Form.Text> : null}

      <div className='pt-4 d-flex w-100 justify-content-center'>
        <Button variant='primary' className='w-100' disabled={!validation.isValid || isSending} onClick={() => onSendLinkClicked(email)} loading={isSending}>
          Send link
        </Button>
      </div>
    </>
  )
}
